import { FC } from 'react';
import { Box, Grid, IconButton, MenuItem, Select, Typography, useTheme } from '@mui/material';
import { t } from 'i18next';
import { KeyboardArrowLeft, KeyboardArrowRight, SkipNext, SkipPrevious } from '@mui/icons-material';
import { usePaginationPages } from './usePaginationPages';

interface props {
  totalRows: number;
  page: number;
  rowsPerPage: number;
  rowsPerPageOptions: number[];
  onChangePage: (newPage: number) => void;
  onChangeRowsPerPage: (rowPerPage: number) => void;
}

export const TablePagination: FC<props> = ({
  page,
  totalRows,
  rowsPerPage,
  rowsPerPageOptions,
  onChangePage,
  onChangeRowsPerPage,
}) => {
  const theme = useTheme();
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const isPagingEnabled = totalPages > 1;

  const pages = usePaginationPages(totalPages, page, onChangePage);

  return (
    <Box mt={theme.spacing(2)}>
      <Grid container width="100%" p="0px" justifyContent="space-between">
        <Grid item p="0px" display="flex" alignItems="center">
          <Typography mr={theme.spacing(2)} variant="body1" color={theme.palette.text.primary}>
            {t('common.tableList.rowsPerPage')}
          </Typography>
          <Select
            size="small"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={rowsPerPage}
            label={t('common.tableList.rowsPerPage')}
            onChange={(e) => onChangeRowsPerPage(+e.target.value || 0)}
          >
            {rowsPerPageOptions.map((value) => (
              <MenuItem key={value} value={value}>
                {value}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid p="0px">
          <Box width="100%" display="flex" justifyContent="flex-end">
            <IconButton disabled={page === 1 || !isPagingEnabled} onClick={() => onChangePage(1)}>
              <SkipPrevious />
            </IconButton>
            <IconButton disabled={page === 1 || !isPagingEnabled} onClick={() => onChangePage(page - 1)}>
              <KeyboardArrowLeft />
            </IconButton>
            {pages}
            <IconButton disabled={page === totalPages || !isPagingEnabled} onClick={() => onChangePage(page + 1)}>
              <KeyboardArrowRight />
            </IconButton>
            <IconButton disabled={page === totalPages || !isPagingEnabled} onClick={() => onChangePage(totalPages)}>
              <SkipNext />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
